export var ItemAdjustType;
(function (ItemAdjustType) {
    ItemAdjustType[ItemAdjustType["ADD"] = 1] = "ADD";
    ItemAdjustType[ItemAdjustType["REMOVE"] = 2] = "REMOVE";
})(ItemAdjustType || (ItemAdjustType = {}));
//# sourceMappingURL=item-adjust-type.js.map